/* global axios */
import ApiClient from './ApiClient';

class SignatureRequestsAPI extends ApiClient {
  constructor() {
    super('signature_requests', { accountScoped: true });
  }

  create(signatureRequest) {
    return axios.post(this.url, { signature_request: signatureRequest });
  }

  void(id) {
    return axios.post(`${this.url}/${id}/void`);
  }
}

export default new SignatureRequestsAPI();
